import React from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { CheckIcon } from '@heroicons/react/24/outline';
import { PageCard, PageShell, PageToolbar } from '../../components/ui';
import { useLocale } from '../../i18n/LocaleProvider';
import i18n from '../../i18n';

const HINT_KEYS = {
    ru: 'settings.ru',
    'uz-Latn': 'settings.uzLatn',
    'uz-Cyrl': 'settings.uzCyrl',
};

export default function Settings() {
    const { t } = useTranslation();
    const { lang, setLang, langs } = useLocale();

    return (
        <PageShell>
            <PageCard>
                <PageToolbar title={t('settings.title')} />
                <div className="px-4 py-4 sm:px-5 sm:py-5">
                    <p className="m-0 mb-4 max-w-xl text-sm text-slate-500">
                        {t('settings.subtitle')}
                    </p>

                    <h2 className="m-0 mb-1 text-sm font-semibold text-slate-800">
                        {t('settings.languageTitle')}
                    </h2>
                    <p className="m-0 mb-4 max-w-xl text-xs text-slate-500">
                        {t('settings.languageHint')}
                    </p>

                    <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-3">
                        {langs.map((item) => {
                            const active = lang === item.code;

                            return (
                                <button
                                    key={item.code}
                                    type="button"
                                    onClick={() => {
                                        if (item.code === lang) return;
                                        setLang(item.code);
                                        toast.success(i18n.t('settings.applied', { lng: item.code }));
                                    }}
                                    className={`flex items-start gap-3 rounded-xl border p-3.5 text-left transition-colors ${
                                        active
                                            ? 'border-[#1D2C7B] bg-[#eef0fb]'
                                            : 'border-slate-200 bg-white hover:border-[#1D2C7B]/40'
                                    }`}
                                >
                                    <span
                                        className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${
                                            active
                                                ? 'bg-[#1D2C7B] text-white'
                                                : 'bg-slate-100 text-slate-600'
                                        }`}
                                    >
                                        {item.short}
                                    </span>
                                    <span className="min-w-0 flex-1">
                                        <span className="block text-sm font-semibold text-slate-800">
                                            {item.name}
                                        </span>
                                        <span className="mt-0.5 block text-xs text-slate-500">
                                            {t(HINT_KEYS[item.code])}
                                        </span>
                                    </span>
                                    {active && (
                                        <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-[#1D2C7B]" />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </PageCard>
        </PageShell>
    );
}
